function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.27339,
  cy: 7.59822,
  r: 7.3072
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.53494 5.65373L8.51267 4.86482C8.64574 4.82623 8.77214 4.75827 8.87698 4.65344C9.20922 4.32119 9.20922 3.78295 8.87683 3.45056C8.54445 3.11818 8.00593 3.11761 7.67354 3.45C7.34115 3.78239 7.34143 4.32119 7.67382 4.65358C7.791 4.77076 7.93428 4.84424 8.08466 4.87886L8.10679 5.66678C8.24908 5.64706 8.39237 5.64195 8.53494 5.65373Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2985 7.32163L11.7443 6.95364C11.7822 7.02187 11.8263 7.08784 11.8841 7.14558C12.217 7.47854 12.7554 7.4784 13.0878 7.14601C13.4201 6.81376 13.4201 6.27552 13.0871 5.94257C12.7547 5.61018 12.2168 5.61018 11.8844 5.94257C11.7194 6.10756 11.6368 6.32319 11.6355 6.53953L10.1939 6.90668C10.2444 7.04088 10.2793 7.1802 10.2985 7.32163Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3979 9.9387C11.1392 9.67994 10.7556 9.62518 10.4413 9.76946L9.76649 8.94679C9.76081 8.95246 9.75627 8.9587 9.75074 8.96423C9.65314 9.06184 9.54702 9.14639 9.43552 9.21902L10.1101 10.0414C9.8682 10.3738 9.8953 10.8412 10.1953 11.1413C10.5276 11.4735 11.0655 11.4735 11.3978 11.1413C11.7299 10.8092 11.7302 10.271 11.3979 9.9387Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.9665 10.2386L7.53055 9.33976C7.40316 9.27819 7.28129 9.20342 7.16695 9.11263L6.60304 10.0119C6.31023 9.92027 5.97883 9.98638 5.74674 10.2185C5.4145 10.5507 5.41464 11.0885 5.74759 11.4215C6.07984 11.7537 6.61779 11.7537 6.9499 11.4216C7.27647 11.0959 7.28058 10.572 6.9665 10.2386Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.74146 6.53626L5.49717 5.91646C5.55391 5.64464 5.47773 5.35056 5.26706 5.13989C4.93467 4.8075 4.39658 4.80764 4.06434 5.13989C3.73166 5.47256 3.73152 6.01065 4.06391 6.34304C4.39602 6.67515 4.93482 6.67572 5.26749 6.34304C5.28139 6.32914 5.29118 6.31339 5.30367 6.29864L6.55179 6.92058C6.60059 6.78751 6.66287 6.65827 6.74146 6.53626Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M7.34435 8.62086C7.91404 9.19055 8.83767 9.19055 9.40735 8.62086C9.97703 8.05118 9.97703 7.12755 9.40735 6.55787C8.83767 5.98818 7.91404 5.98819 7.34436 6.55787C6.77467 7.12755 6.77467 8.05118 7.34435 8.62086Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.2104,
  cy: 15.3624,
  r: 5.9371,
  fill: "#F1F2F5"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5364 17.3384V16.4859L14.1748 14.766C14.3823 14.5386 14.5306 14.341 14.6196 14.1729C14.7135 13.9999 14.7604 13.827 14.7604 13.654C14.7604 13.2092 14.4861 12.9868 13.9375 12.9868C13.725 12.9868 13.5125 13.0288 13.3 13.1128C13.0875 13.1919 12.8799 13.3155 12.6773 13.4835L12.3066 12.6384C12.5241 12.4506 12.791 12.3023 13.1073 12.1936C13.4285 12.0849 13.7571 12.0305 14.0932 12.0305C14.6764 12.0305 15.1212 12.1615 15.4276 12.4234C15.739 12.6804 15.8946 13.0486 15.8946 13.528C15.8946 13.8443 15.8205 14.1482 15.6722 14.4398C15.5289 14.7264 15.2917 15.0378 14.9606 15.3739L13.9524 16.3969H16.0874V17.3384H12.5364Z",
  fill: "#23244D",
  fillOpacity: 0.5
});

var SvgChannels2Icon = function SvgChannels2Icon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChannels2Icon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/channels-2-icon.35135fbe.svg";
export { ForwardRef as ReactComponent };